import React from 'react';
import PropTypes from 'prop-types';
import {TextField, Toolbar} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Search from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import ScreenDesignerListHoc from "../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import ToolBarDropAria from "./ToolBarDropAria";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../../JsonScreen/Utils/lib";

const TableToolbarList = (props) => {
    const {
        gridProps: {hideListHeader, hideQuickSearch, hideAdvancedSearch} = {},
        name, list, path, parentPath
    } = props;
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(name, userLanguage)
    return (
        <Toolbar style={{minHeight: 0, paddingLeft: 15, paddingRight: 0}}>
            <div style={{flexGrow: 1, display: 'flex', alignItems: 'center'}}>
                <div>
                    <ToolBarDropAria
                        path={path}
                        parentPath={parentPath}
                        component={list.children && list.children.length > 2 ? list.children[2].children : []}
                        panelIndex={2}
                    />
                </div>

                <span style={{fontSize: '1.2em', fontWeight: 500}} id="tableTitle">
                    {multiLanguageLabel}
                </span>
                <div>
                    <ToolBarDropAria
                        path={path}
                        parentPath={parentPath}
                        component={list.children && list.children.length > 3 ? list.children[3].children : []}
                        panelIndex={3}
                    />
                </div>
            </div>
            {!hideListHeader && (
                <>
                    <div style={{marginRight: 15}}>
                        <ToolBarDropAria
                            path={path}
                            parentPath={parentPath}
                            component={list.children && list.children.length > 0 ? list.children[0].children : []}
                            panelIndex={0}
                        />
                    </div>
                    {!hideQuickSearch && <RenderSearchBar/>}
                    {!hideAdvancedSearch && <RenderFilter/>}
                    <ToolBarDropAria
                        path={path}
                        parentPath={parentPath}
                        component={list.children && list.children.length > 1 ? list.children[1].children : []}
                        panelIndex={1}
                    />
                </>
            )}
        </Toolbar>
    )
};

export default ScreenDesignerListHoc(TableToolbarList);

TableToolbarList.propTypes = {
    gridProps: PropTypes.object,
    label: PropTypes.string,
    list: PropTypes.object,
    path: PropTypes.string,
    parentPath: PropTypes.string
};

const RenderFilter = () => {
    return (
        <IconButton id="filterList"
                    style={{padding: 0}}
                    aria-label="filter list"
                    disabled={true}
        >
            <FilterListIcon/>
        </IconButton>
    )
};
const RenderSearchBar = () => {
    return (
        <TextField
            placeholder="Search..."
            id="tableSearch"
            disabled={true}
            InputProps={{
                style: {width: 100},
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton
                            disabled
                            style={{padding: 0}}
                            edge="start"
                            aria-label="search menu items"
                        >
                            <Search/>
                        </IconButton>
                    </InputAdornment>),
            }}
        />
    )
};
